import { createFeature, createReducer, on } from "@ngrx/store";

import { LoadingState } from "../../utilities/state.util";

import { CancelAndCloseDialogActions } from "./cancel-and-close-dialog.actions";
import { CancelAndCloseDialogState, cancelAndCloseDialogInitialState } from "./cancel-and-close-dialog.state";

export const cancelAndCloseDialogFeature = createFeature({
  name: 'cancelAndCloseDialog',
  reducer: createReducer(
    cancelAndCloseDialogInitialState,
    on(CancelAndCloseDialogActions.openCancelAndCloseDialogTriggered, (state, { jobId, trigger, eventIds }): CancelAndCloseDialogState => {
      const eventsToCancel: Record<string, boolean> = {};

      for (const id of eventIds ?? []) {
        eventsToCancel[id] = true;
      }

      return {
        ...state,
        jobId,
        trigger,
        eventsToCancel,
        closedReason: undefined,
      };
    }),
    on(CancelAndCloseDialogActions.eventCardClicked, (state, { eventId }): CancelAndCloseDialogState => {
      const eventsToCancel = { ...state.eventsToCancel };

      if (eventsToCancel[eventId]) {
        delete eventsToCancel[eventId];
      } else {
        eventsToCancel[eventId] = true;
      }

      return {
        ...state,
        eventsToCancel,
      };
    }),
    on(CancelAndCloseDialogActions.closureReasonSelected, (state, { closedReason }): CancelAndCloseDialogState => {
      return {
        ...state,
        closedReason,
      };
    }),
    on(CancelAndCloseDialogActions.continueButtonClicked, (state, { command }): CancelAndCloseDialogState => {
      if (command === 'cancel') {
        return {
          ...state,
          cancelEventsCall: LoadingState.MUTATING,
        };
      }

      return {
        ...state,
        view: 'close',
      };
    }),
    on(CancelAndCloseDialogActions.cancelEventsSuccess, (): CancelAndCloseDialogState => {
      return { ...cancelAndCloseDialogInitialState };
    }),
    on(CancelAndCloseDialogActions.cancelEventsError, (state, { error }): CancelAndCloseDialogState => {
      return {
        ...state,
        cancelEventsCall: { error },
      };
    }),
    on(CancelAndCloseDialogActions.cancelEventsOnlyButtonClicked, (state): CancelAndCloseDialogState => {
      return {
        ...state,
        cancelEventsCall: LoadingState.MUTATING,
      };
    }),
    on(CancelAndCloseDialogActions.closeJobButtonClicked, (state): CancelAndCloseDialogState => {
      return {
        ...state,
        cancelAndCloseCall: LoadingState.MUTATING,
      };
    }),
    on(CancelAndCloseDialogActions.cancelAndCloseSuccess, (): CancelAndCloseDialogState => {
      return { ...cancelAndCloseDialogInitialState };
    }),
    on(CancelAndCloseDialogActions.cancelAndCloseError, (state, { error }): CancelAndCloseDialogState => {
      return {
        ...state,
        cancelAndCloseCall: { error },
      };
    }),
    on(CancelAndCloseDialogActions.backButtonClicked, (state): CancelAndCloseDialogState => {
      return {
        ...state,
        view: 'cancel',
      };
    }),
    on(CancelAndCloseDialogActions.exitButtonClicked, (): CancelAndCloseDialogState => {
      return { ...cancelAndCloseDialogInitialState };
    }),
  ),
});
